import i18next from 'i18next';
import { fetch } from '@microsoft/portal-app/lib/fetch';
import { topicIds } from '../constants';
import {
  actionContactPreferenceUserSave,
  actionContactPreferenceUserSaveSuccess,
  actionContactPreferenceUserSaveError,
} from '../actions';
import { selectContactPreferenceUserSaveDisabled } from '../selectors';
import { IEnduserEmailContactsPatch } from './models';
import { IContactPreferenceUserSave } from '../models';
import { createThunk } from '../../redux';
import { auth } from '../../auth';
import { settingsManager } from '../../shared/settings';

export const effectContactPreferenceUserSave = createThunk(
  async (dispatch, getState, data: IContactPreferenceUserSave) => {
    if (selectContactPreferenceUserSaveDisabled(getState())) {
      return;
    }

    const audience = settingsManager.getRequired('cpmAudience');
    const baseUrl = settingsManager.getRequired('cpmBaseUrl');

    dispatch(actionContactPreferenceUserSave(data));

    const token = await auth.acquireToken({ scopes: [audience] });
    const user = auth.user;
    const tenantId = user?.tenantId ?? '';
    const objectId = user?.objectId ?? '';
    const { productsOptIn } = data;
    const body: IEnduserEmailContactsPatch = {
      tenantId,
      objectId,
      userType: 'endUser',
      topicSettings: [
        {
          cultureName: i18next.languages[0] ?? i18next.language ?? 'en-US',
          originalSource: auth.clientId,
          topicId: topicIds.products,
          state: productsOptIn ? 'optInExplicit' : 'optOut',
        },
      ],
    };
    const response = await fetch(`${baseUrl}/api/EnduserEmailContacts`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw Error(`error response from PATCH ${response.url} (status: ${response.status})`);
    }

    dispatch(actionContactPreferenceUserSaveSuccess());
  },
  (error, dispatch) => {
    dispatch(actionContactPreferenceUserSaveError(error));
  },
);
